"use client";

import { type ReactNode } from "react";

import {
  AlertDialog,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";
import { Button } from "~/components/ui/button";

export interface WorkspaceErrorDialogProps {
  open: boolean;
  title: string;
  message: string;
  detail?: string | undefined;
  onRetry?: (() => void) | undefined;
  onCancel: () => void;
  retryLabel?: string;
  cancelLabel?: string;
  children?: ReactNode;
}

export function WorkspaceErrorDialog({
  open,
  title,
  message,
  detail,
  onRetry,
  onCancel,
  retryLabel = "Reintentar",
  cancelLabel = "Cerrar",
  children,
}: WorkspaceErrorDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onCancel();
      }}
    >
      <AlertDialogPopup>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        {detail ? (
          <pre className="mx-6 max-h-48 overflow-auto rounded-md bg-muted p-3 text-xs text-muted-foreground whitespace-pre-wrap">
            {detail}
          </pre>
        ) : null}
        {children}
        <div className="flex flex-row-reverse gap-2 p-6 pt-2">
          {onRetry ? (
            <Button
              type="button"
              onClick={() => {
                onRetry();
              }}
            >
              {retryLabel}
            </Button>
          ) : null}
          <Button type="button" variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
        </div>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
